import { render } from "./BlockLogin.vue?vue&type=template&id=1e6caafe&ts=true"
import script from "./BlockLogin.vue?vue&type=script&lang=ts"
export * from "./BlockLogin.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__